// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"FacilityDetails_infoWrapper__11hVz"};